import { robotoRegular } from '@habitech/shared';
import styled from 'styled-components';

export const WrapperAutocomplete = styled.div`
  max-height: calc(100vh - 222px);
  overflow-y: auto;
  .card-title {
    font-size: 15px;
    font-family: ${robotoRegular};
    margin-bottom: 4px;
    font-weight: 900;
  }
  .recharts-cartesian-axis-ticks {
    font-size: 14px;
    font-family: ${robotoRegular};
  }
  .card-sub-title {
    font-size: 14px;
    font-family: ${robotoRegular};
  }
  .badge-ctl {
    background-color: #7f8dd6 !important;
  }
  .badge-deed {
    background-color: #57abd0 !important;
  }
  .badge-admin {
    background-color: #e79633 !important;
  }
  .badge-hubspot {
    background-color: #61d298 !important;
  }
  .badge-beepquest {
    background-color: #d97bc4 !important;
  }
  .badge-appraisal {
    background-color: #5b9bd5 !important;
  }
  .badge-polynator {
    background-color: #70ad47 !important;
  }
  .badge-bigquery {
    background-color: #4285f4 !important;
  }
  .badge-sig {
    background-color: #b77a8f !important;
  }
  .badge-google-maps {
    background-color: #ea4335 !important;
  }
  .badge-report-remo {
    background-color: #ff6f61 !important;
  }
  .badge-georeference {
    background-color: #9c27b0 !important;
  }
  .badge-my-maps {
    background-color: #00bcd4 !important;
  }
  .badge-remo-measurement {
    background-color: #ff9800 !important;
  }
  .badge-pricing {
    background-color: #4caf50 !important;
  }
  .badge-video-vo {
    background-color: #673ab7 !important;
  }
  .badge-agent-automatic {
    background-color: #607d8b !important;
  }
  .badge-property-tax {
    background-color: #a1887f !important;
  }
`;
